import axios from 'axios';
import {
  GET_TERMS_CONDITIONS,
  ADD_TERMS_CONDITION,
  DELETE_TERMS_CONDITION,
  UPDATE_TERMS_CONDITION,
  TERMS_CONDITIONS_LOADING,
  GET_AVAILABLE_PROGRAMS,
  GET_TERMS_BY_PROGRAM
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

export const getTermsConditions = () => (dispatch, getState) => {
  dispatch({ type: TERMS_CONDITIONS_LOADING });
  axios
    .get('/api/terms-conditions', tokenConfig(getState))
    .then(res => dispatch({ type: GET_TERMS_CONDITIONS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const getAvailablePrograms = () => (dispatch, getState) => {
  axios
    .get('/api/terms-conditions/available-programs', tokenConfig(getState))
    .then(res => dispatch({ type: GET_AVAILABLE_PROGRAMS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const addTermsCondition = termsCondition => (dispatch, getState) => {
  axios
    .post('/api/terms-conditions', termsCondition, tokenConfig(getState))
    .then(res => dispatch({ type: ADD_TERMS_CONDITION, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const updateTermsCondition = (id, termsCondition) => (dispatch, getState) => {
  axios
    .put(`/api/terms-conditions/${id}`, termsCondition, tokenConfig(getState))
    .then(res => dispatch({ type: UPDATE_TERMS_CONDITION, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const deleteTermsCondition = id => (dispatch, getState) => {
  axios
    .delete(`/api/terms-conditions/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: DELETE_TERMS_CONDITION, payload: id }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const getTermsByProgram = programId => dispatch => {
  axios
    .get(`/api/terms-conditions/program/${programId}`)
    .then(res => dispatch({ type: GET_TERMS_BY_PROGRAM, payload: res.data }))
    .catch(() => {
      // No terms found for this program — set to empty so the UI can skip the step
      dispatch({ type: GET_TERMS_BY_PROGRAM, payload: null });
    });
};